module.exports = __webpack_public_path__ + "img/4.df140c3d.png";